import { useCachedQuery } from '@kaiizen/react-persistent-cache';
import { useAuth } from '../useAuth';
import { useKaiProApiClient } from '../useKaiProApiClient';

// kaiProApiClient.getUsersByOrgMarketId

export const useMarketsByUserId = (userId?: string) => {
  const kaiProApiClient = useKaiProApiClient();
  const { orgId, token } = useAuth();
  const query = useCachedQuery(
    `markets/byUserId/${orgId ?? 'no-org'}/${userId}/${token ?? 'no-token'}`,
    () => kaiProApiClient.getMarketsByUserId(userId!),
    { enabled: !!kaiProApiClient.token && !!userId && !!orgId },
  );
  return {
    ...query,
    markets: query.data,
  };
};
